import { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Grid } from "@mui/material";

import { wrapper } from "../../redux/store";
import { getLatestBooks } from "../../redux/actions/books.action";

import Breadcrumb from "../../components/Common/Breadcrumb.component";
import ContentBox from "../../components/Common/ContentBox.component";
import CustomCard from "../../components/Common/CustomCard.component";
import CustomPagination from "../../components/Common/CustomPagination.component";
import CardSkeleton from "../../components/Common/CardSkeleton.component";

import {
  calculateTotalPageByTotalDocs,
  skeletonArray,
} from "../../services/utils";
import { DOCS_PER_PAGE } from "../../services/constants";

const listBreadcrumbChildren = [
  {
    name: "Sách mới",
    href: "/new-books",
  },
];

const NewBooks = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [sortingValue, setSortingValue] = useState("-createdAt");
  const { latestBooks } = useSelector((state) => state.books);
  const dispatch = useDispatch();

  const handleChangePagination = (_event, page) => {
    if (page === currentPage || page === null) {
      return;
    }
    setCurrentPage(page);
    setIsLoading(true);
    const params = {
      fields: "-borrowQuantity",
      limit: DOCS_PER_PAGE,
      page,
      sort: sortingValue,
    };
    dispatch(getLatestBooks(params));
    window.scrollTo(0, 0);
  };

  const totalPages = useMemo(() => {
    if (latestBooks) {
      return calculateTotalPageByTotalDocs(latestBooks.totalDocs);
    }
  }, [latestBooks]);

  useEffect(() => {
    if (latestBooks) setIsLoading(false);
  }, [latestBooks]);

  return (
    <div>
      <Breadcrumb listBreadcrumbChildren={listBreadcrumbChildren} />
      <ContentBox
        title="Sách mới"
        infoType="books"
        haveSorting
        sortingValue={sortingValue}
        setCurrentPage={setCurrentPage}
        setIsLoading={setIsLoading}
        setSortingValue={setSortingValue}
      >
        <Grid container spacing={4}>
          {isLoading
            ? skeletonArray.map((_, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <CardSkeleton />
                </Grid>
              ))
            : latestBooks?.books?.map((book) => (
                <Grid item xs={12} sm={6} md={3} key={book._id}>
                  <CustomCard info={book} haveCategoryLink infoType="books" />
                </Grid>
              ))}
        </Grid>
        <CustomPagination
          count={totalPages}
          page={currentPage}
          onChange={handleChangePagination}
        />
      </ContentBox>
    </div>
  );
};

export const getStaticProps = wrapper.getStaticProps((store) => async () => {
  const params = {
    fields: "-borrowQuantity",
    limit: DOCS_PER_PAGE,
    page: 1,
  };
  await store.dispatch(getLatestBooks(params));

  return {
    props: {},
    revalidate: 1,
  };
});

export default NewBooks;
